export default "immagini/hotel-benchmark-logo.svg"